import { createGlobalStyle } from "styled-components"

/**
 * Backoffice design tokens. Every colour, radius, shadow and motion curve lives here as a CSS
 * variable, so screens reference `var(--bo-…)` (or the `T` map) and never hard-code hex.
 */
export const T = {
	canvas: "var(--bo-canvas)", surface: "var(--bo-surface)", surface2: "var(--bo-surface-2)", hover: "var(--bo-hover)",
	border: "var(--bo-border)", borderStrong: "var(--bo-border-strong)",
	text: "var(--bo-text)", text2: "var(--bo-text-2)", muted: "var(--bo-muted)", faint: "var(--bo-faint)",
	primary: "var(--bo-primary)", accent: "var(--bo-accent)", accentHover: "var(--bo-accent-hover)", accentSoft: "var(--bo-accent-soft)", accentText: "var(--bo-accent-text)",
	success: "var(--bo-success)", successSoft: "var(--bo-success-soft)", successLine: "var(--bo-success-line)",
	warn: "var(--bo-warn)", warnSoft: "var(--bo-warn-soft)", warnLine: "var(--bo-warn-line)",
	danger: "var(--bo-danger)", dangerSoft: "var(--bo-danger-soft)", dangerLine: "var(--bo-danger-line)",
	info: "var(--bo-info)", infoSoft: "var(--bo-info-soft)",
	shadowSm: "var(--bo-shadow-sm)", shadowMd: "var(--bo-shadow-md)", shadowLg: "var(--bo-shadow-lg)",
	radius: "var(--bo-radius)", radiusLg: "var(--bo-radius-lg)", ease: "var(--bo-ease)"
} as const

export const AdminGlobalStyle = createGlobalStyle`
	:root {
		--bo-canvas: #EBECF0; --bo-surface: #FFFFFF; --bo-surface-2: #F6F6F9; --bo-hover: #EEEEF2;
		--bo-border: #DFDFE6; --bo-border-strong: #C6C6D0;
		--bo-text: #0F0F13; --bo-text-2: #2C2C34; --bo-muted: #565662; --bo-faint: #82828E;
		--bo-primary: #17171C;
		--bo-accent: #5046E5; --bo-accent-hover: #4338CA; --bo-accent-soft: #EBEBFF; --bo-accent-text: #4338CA;
		--bo-success: #0F6E33; --bo-success-soft: #EDFBF2; --bo-success-line: #B7EBC9;
		--bo-warn: #8C4F04; --bo-warn-soft: #FFF8EB; --bo-warn-line: #F8DDA7;
		--bo-danger: #B42B07; --bo-danger-soft: #FFF3F0; --bo-danger-line: #FBCFC2;
		--bo-info: #1D5FD1; --bo-info-soft: #EFF5FF;
		--bo-shadow-sm: 0 1px 2px rgba(15, 15, 19, .06), 0 2px 8px -2px rgba(15, 15, 19, .08);
		--bo-shadow-md: 0 1px 2px rgba(23, 23, 28, .04), 0 6px 16px -4px rgba(23, 23, 28, .08);
		--bo-shadow-lg: 0 2px 6px rgba(23, 23, 28, .06), 0 28px 60px -12px rgba(23, 23, 28, .28);
		--bo-radius: 10px; --bo-radius-lg: 14px;
		--bo-ease: cubic-bezier(.2, .8, .2, 1);
		color-scheme: light;
	}

	body {
		font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
		font-feature-settings: "cv11", "ss01", "ss03";
		color: var(--bo-text);
		background: var(--bo-canvas);
	}

	::selection { background: rgba(80, 70, 229, .16); }
	::-webkit-scrollbar { width: 10px; height: 10px; }
	::-webkit-scrollbar-track { background: transparent; }
	::-webkit-scrollbar-thumb { background: rgba(23, 23, 28, .14); border-radius: 10px; border: 3px solid transparent; background-clip: padding-box; }
	::-webkit-scrollbar-thumb:hover { background: rgba(23, 23, 28, .28); background-clip: padding-box; border: 3px solid transparent; }

	:focus-visible { outline: 2px solid var(--bo-accent); outline-offset: 2px; }

	@keyframes bo-rise { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
	@keyframes bo-fade { from { opacity: 0; } to { opacity: 1; } }
	@keyframes bo-pop { from { opacity: 0; transform: translateY(8px) scale(.98); } to { opacity: 1; transform: none; } }
	@keyframes bo-shimmer { from { background-position: 100% 0; } to { background-position: -100% 0; } }

	@media (prefers-reduced-motion: reduce) {
		*, *::before, *::after { animation-duration: .01ms !important; transition-duration: .01ms !important; }
	}
`
